import { Component, input, output } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'gnx-dialog-header',
  imports: [SharedModule],
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
})
export class DialogHeaderComponent {
  readonly title = input<string>(undefined);
  readonly subTitle = input<string>(undefined);
  readonly close = output<void>();
}
